// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCqmShH_5dZOmMv_iL9_e9TLeim2y4Bk-g',
  authDomain: 'herrmann-media.firebaseapp.com',
  databaseURL: 'https://herrmann-media-default-rtdb.firebaseio.com',
  projectId: 'herrmann-media',
  storageBucket: 'herrmann-media.appspot.com',
  messagingSenderId: '1091121138931',
  appId: '1:1091121138931:web:1c031df691be1574a2fb86',
  measurementId: 'G-CDXDBPJ95R',
}

// Initialize Firebase
const firbaseApp = initializeApp(firebaseConfig)
const analytics = getAnalytics(firbaseApp)

export default firbaseApp
